import { render, staticRenderFns } from "./ColdAndHot_Index.vue?vue&type=template&id=3ab95868&scoped=true"
import script from "./ColdAndHot_Index.vue?vue&type=script&lang=js"
export * from "./ColdAndHot_Index.vue?vue&type=script&lang=js"
import style0 from "./ColdAndHot_Index.vue?vue&type=style&index=0&id=3ab95868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab95868",
  null
  
)

export default component.exports